module.exports = __webpack_public_path__ + "static/img/qpd.2eadbaba.png";